<template>
  <div>
    <vs-breadcrumb>
      <li>
        <a
          aria-current="page"
          style="color: rgba(0, 0, 0, 0.4)"
          title="Device Management"
          >Device Management</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'gateway'" title="Gateway">Gateway</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">View Gateway</li>
    </vs-breadcrumb>
    <pre>{{ this.selectFilterActive }}</pre>
    <vs-card style="border-radius: 20px">
      <div class="mt-2 ml-1" slot="header">
        <h4>
          {{ gateway.name }}
        </h4>
      </div>
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          class="p-3"
          vs-sm="4"
          vs-xs="4"
        >
          <img
            src="../../../../assets/images/sensor/sensor.jpg"
            width="200"
            height="100"
          />
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-lg="7" vs-sm="7" vs-xs="8">
          <!-- <ul>
      <p class="mt-3 mb-2">Name : {{sensorname}}</p>
      <p class="mt-3 mb-2">Serial Number : {{sensorid}}</p>
      <p class="mt-3 mb-2">Type : {{type}}</p>
      <p class="mt-3 mb-2">Network : {{nwname}}</p>
      <p class="mt-3 mb-2">Location : Unavailable</p>
      <p v-if="statussensor || type == 'control'" class="mt-3 mb-2">Status :  Active</p>
      <p v-else class="mt-3 mb-2">Status :  Inactive</p>
      
    </ul> -->
          <!-- <b-table stacked :items="items"></b-table> -->
          <div style="width: 100%">
            <vs-row vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <span class="font-weight-bold">Gateway Name</span>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <span>{{ gateway.name }}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <span class="font-weight-bold textNowrap">Network</span>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <span>{{ gateway.network }}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <span class="font-weight-bold">Serial ID</span>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <span>{{ gateway.serial_id }}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <span class="font-weight-bold">Type</span>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <span> {{ gateway.type }}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <span class="font-weight-bold">Last Seen</span>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <span> {{ lastseen }}</span>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
    <vs-card style="border-radius: 20px">
      <div class="mt-2 ml-1" slot="header">
        <h4>Sensor</h4>
      </div>
      <div class="mt-3 ml-2 filterContentHeader">
        <span class="mr-2">Filter by :</span>
        <vs-select
          placeholder="Select filter"
          multiple
          class="fontSizeData"
          v-model="searchHeader"
        >
          <vs-select-item
            :key="index"
            :value="item"
            :text="item"
            v-for="(item, index) in headerFilter"
          />
        </vs-select>
      </div>
      <vs-row>
        <div
          class="mt-2 fontSizeData"
          v-for="header in searchHeader"
          :key="header"
        >
          <div v-if="header == 'Name'">
            <div class="textfill textSuccess"><span>Name</span></div>
            <div class="contentitem">
              <vs-input
                class="inputx"
                placeholder="Search Name"
                v-model="selectFilterName"
              />
              <vs-icon
                class="clearIcon"
                size="0.9rem"
                color="light"
                @click="remove(header)"
                icon="close"
              ></vs-icon>
            </div>
          </div>
          <div v-if="header == 'Serial Number'">
            <div class="textfill textSuccess"><span>Serial Number</span></div>
            <div class="contentitem">
              <vs-select
                placeholder="Select Serial Number"
                v-model="selectFilterSerialNumber"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item"
                  v-for="(item, index) in filterSerialNumber"
                />
              </vs-select>
              <vs-icon
                class="clearIcon"
                size="0.9rem"
                color="light"
                @click="remove(header)"
                icon="clear"
              ></vs-icon>
            </div>
          </div>
          <div v-if="header == 'Type'">
            <div class="textfill textSuccess"><span>Type</span></div>
            <div class="contentitem">
              <vs-select placeholder="Select Type" v-model="selectFilterType">
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item"
                  v-for="(item, index) in filterType"
                />
              </vs-select>
              <vs-icon
                class="clearIcon"
                size="0.9rem"
                color="light"
                @click="remove(header)"
                icon="clear"
              ></vs-icon>
            </div>
          </div>
          <div v-if="header == 'Network'">
            <div class="textfill textSuccess"><span>Network</span></div>
            <div class="contentitem">
              <vs-select
                placeholder="Select Network"
                v-model="selectFilterNetwork"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item"
                  v-for="(item, index) in filterNetwork"
                />
              </vs-select>
              <vs-icon
                class="clearIcon"
                size="0.9rem"
                color="light"
                @click="remove(header)"
                icon="clear"
              ></vs-icon>
            </div>
          </div>
          <div v-if="header == 'Status'">
            <div class="textfill textSuccess"><span>Device Status</span></div>
            <div class="contentitem">
              <vs-select placeholder="Select Type" v-model="selectFilterActive">
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in filterActive"
                />
              </vs-select>
              <vs-icon
                class="clearIcon"
                size="0.9rem"
                color="light"
                @click="remove(header)"
                icon="clear"
              ></vs-icon>
            </div>
          </div>
        </div>
      </vs-row>
      <vs-table :data="filteredList" search>
        <template slot="thead">
          <!-- <vs-th style="padding: 0px">
            </vs-th> -->
          <vs-th v-for="item in header" :key="item" sort-key="name" id="noWrap">
            {{ item }}
            <span><vs-icon icon="unfold_more" size="0.75rem"></vs-icon></span>
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              <vs-button
                class="textNowrap"
                @click="viewSensor(indextr)"
                icon="signal_cellular_alt"
                type="flat"
                >{{ data[indextr].name }}</vs-button
              >
            </vs-td>
            <vs-td :data="data[indextr].serial_id">
              {{ data[indextr].serial_id }}
            </vs-td>
            <vs-td :data="data[indextr].type">
              {{ data[indextr].type }}
            </vs-td>
            <vs-td :data="data[indextr].network">
              {{ data[indextr].network }}
            </vs-td>
            <vs-td :data="data[indextr].islocated"> {{data[indextr].islocated}} </vs-td>
            <vs-td :data="data[indextr].active">
               <div v-if="data[indextr].active == '0'">
                <vs-icon icon="fiber_manual_record" color="gray"></vs-icon>
              </div>
              <div v-if="data[indextr].active == '1'">
                <vs-icon icon="fiber_manual_record" color="success"></vs-icon>
              </div>
              <div v-if="data[indextr].active == '2'">
                <vs-icon icon="fiber_manual_record" color="warning"></vs-icon>
              </div>
             

              <!-- <vs-icon icon="fiber_manual_record" v-else color="grey"></vs-icon> -->
            </vs-td>
            <vs-td :data="data[indextr].signal">
              <!-- {{ data[indextr].signal }} -->
              <vs-icon icon="rss_feed" color="primary"></vs-icon>
            </vs-td>
            <vs-td :data="data[indextr].bat">
              <!-- {{ data[indextr].bat }} -->
              <vs-icon icon="battery_full" color="primary"></vs-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: "ViewGateway",
  props: ["gateway"],
  data: () => ({
    serial: "",
    security: "",
    name: "",
    type: "",
    sensorList: [],
    headerFilter: ["Name", "Serial Number", "Type", "Network", "Status"],
    header: [
      "Name",
      "Serial Number",
      "Type",
      "Network",
      "Location",
      "Active Status",
      "Signal",
      "Battery",
    ],
    sensor: {
      id: null,
      name: null,
      serial: null,
      security: null,
      type: null,
      subtype: null,
    },
    lastseen: "",
    sensorId: [],
    searchHeader: "",
    searchItem: [],
    selectFilterName: "",
    filterType: [],
    filterItem: [],
    selectFilterType: "",
    filterType: [],
    filterNetwork: [],
    selectFilterNetwork: "",
    filterLocation: [],
    filterSerialNumber: [],
    filterActive: [
      { text: "Offline", value: '0' },
      { text: "Active", value: '1' },
      { text: "Inactive", value: '2'},
    ],
    // filterActive: [],
    selectFilterSerialNumber: "",
    selectFilterActive: "",
    filterSignal: "",
  }),
  components: {},
  methods: {
    remove(item) {
      this.searchHeader.splice(this.searchHeader.indexOf(item), 1);
      switch (item) {
        case "Name":
          this.selectFilterName = "";
          break;
        case "Type":
          this.selectFilterType = "";
          break;
        case "Serial Number":
          this.selectFilterSerialNumber = "";
          break;
        case "Network":
          this.selectFilterNetwork = "";
          break;
        case "Location":
          this.selectFilterLocation = "";
          break;
        case "Status":
          this.selectFilterActive = "";
          break;
        default:
          console.log("Try looking up for a hint.");
      }
    },
    viewSensor(item) {
      console.log(item);
      console.log(this.sensorId[item]);
      this.$API.get("sensors/user").then((result) => {
        let sensor = result.data.filter(
          (sensor) => sensor.id == this.sensorId[item]
        );
        if (sensor) {
          let item = sensor[0];
          this.$session.set("nwname", item.network);
          this.$session.set("statussensor", item.active);
          this.$session.set("nwid", item.nwid);
          this.$session.set("sensorname", item.name);
          this.$session.set("sensorid", item.serial_id);
          this.$session.set("gatewayid", item.gatewayid);
          this.$session.set("type", item.type);
          this.$session.set("lora", item.lora);
          this.$session.set("id", item.id);
          this.$router.push({
            name: "SensorDashboard",
            params: {
              // nwname: sensor.network,
              nwid: item.nwid,
              sensorid: item.serial_id,
              gatewayid: item.gatewayid,
              type: item.type,
              id: item.id,
            },
          });
        }
      });
    },
  },
  created() {
    console.log(this.gateway.networkID);
    this.$API.get("sensor/" + this.gateway.networkID).then((result) => {
      // this.sensorList = result.data;
      result.data.forEach((element) => {
        this.sensorList.push({
          name: element.name,
          serial_id: element.serial_id,
          type: element.type,
          network: element.network,
          location: element.location,
          active: element.active,
          signal: "100",
          bat: "100",
        });
        this.sensorId.push(element.id);
        // console.log(this.sensorId);
        this.filterType.push(element.type);
        this.filterNetwork.push(element.network);
        this.filterLocation.push(element.location);
        this.filterSerialNumber.push(element.serial_id);
        // this.filterActive.push(element.active);
      });
      console.log(result.data);
      this.filterType = new Set(this.filterType);
      this.filterNetwork = new Set(this.filterNetwork);
      this.filterLocation = new Set(this.filterLocation);
      this.filterSerialNumber = new Set(this.filterSerialNumber);
    });

    // console.log(this.filterType);

    //   this.$API.get('gatewaysensor/'+this.gateway.networkID+'/'+this.$session.get('token')).then((result) => {
    //   this.sensorList = result.data
    //   console.log(result.data)
    // })
    this.$API
      .post("getlastseen", {
        gid: this.gateway.serial_id,
        type: this.gateway.type,
      })
      .then((result) => {
        // console.log(result.data)
        this.lastseen = this.$moment(result.data.firstSeenAt).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      });
  },
  computed: {
    filteredList() {
      console.log(this.selectFilterActive);
      return this.sensorList.filter((post) => {
        console.log(post.active);
        return (
          post.name
            .toString()
            .toLowerCase()
            .includes(this.selectFilterName.toLowerCase()) &&
          post.type
            .toString()
            .toLowerCase()
            .includes(this.selectFilterType.toLowerCase()) &&
          post.serial_id
            .toString()
            .toLowerCase()
            .includes(this.selectFilterSerialNumber.toLowerCase()) &&
          post.network
            .toString()
            .toLowerCase()
            .includes(this.selectFilterNetwork.toLowerCase()) &&
          post.active.toString().toLowerCase().includes(this.selectFilterActive.toLowerCase())
        );
      });
    },
  },
};
</script>
<style scoped>
#noWrap {
  padding: 0px;
  white-space: nowrap;
  font-size: 0.75rem;
}
img {
  max-width: 100%;
  height: auto;
}
.vs-button {
  border-radius: 20px;
}
.textRight {
  text-align: right;
}
@media only screen and (max-width: 530px) {
  .textResponsive {
    text-align: left;
  }
}
</style>